var map = {
	"./foot-left.svg": "DlNi",
	"./foot-right.svg": "Fu0V",
	"./fullscreen-expand.svg": "pYy7",
	"./fullscreen-shrink.svg": "hGao",
	"./im-new.svg": "nA9k",
	"./im.svg": "22fw",
	"./refresh.svg": "uMRt",
	"./setting.svg": "Bf+v",
	"./telephone-fill.svg": "+w1b",
	"./telephone.svg": "2jFW",
	"./toco-reset.svg": "IT2G",
	"./userlist.svg": "0EXp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";